import React, { useState } from 'react';
import { FilterInfoModalContext } from './FilterInfoModalContext';
import { filterInfo } from '../../config/filters';

/**
 * Wrapper to make a Provider for the FilterInfoModalContext.
 * @returns {React.Provider<FilterInfoModalContext>}
 */
const FilterInfoModalProvider = ({ children }) => {
    const [isFilterInfoModalOpen, setIsFilterInfoModalOpen] = useState(false);
    const [currentSelectedFilter, setCurrentSelectedFilter] = useState(null);
    const selectedFilterData = currentSelectedFilter === null ? null : filterInfo[currentSelectedFilter];

    return (
        <FilterInfoModalContext.Provider value={{ 
            isFilterInfoModalOpen,
            setIsFilterInfoModalOpen,
            currentSelectedFilter,
            setCurrentSelectedFilter, 
            selectedFilterData
         }}>
            {children}
        </FilterInfoModalContext.Provider>
    );
};

export default FilterInfoModalProvider;
